import { render, staticRenderFns } from "./SecondTag.vue?vue&type=template&id=47c5c704&scoped=true&"
import script from "./SecondTag.vue?vue&type=script&lang=js&"
export * from "./SecondTag.vue?vue&type=script&lang=js&"
import style0 from "./SecondTag.vue?vue&type=style&index=0&id=47c5c704&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c5c704",
  null
  
)

export default component.exports